import React, { useEffect, useState } from 'react';
import PopupNotification from './PopupNotification';
import { Form, Button, DatePicker } from 'antd';
import CircularProgress from '@mui/material/CircularProgress';
import axios from 'axios';
import { useDispatch } from 'react-redux';
import { setLoading } from '../store/feedback';
import moment from 'moment';
import dayjs from 'dayjs';
import './auditCreation.css';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import './createAudit.css';
import {
  StyledInput,
  StyledSelect,
} from '../login-module/customComponents/styled_input';
import { useNavigate } from 'react-router-dom';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import { v4 as uuidv4 } from 'uuid';
import { useParams } from 'react-router-dom';
import { useLocation } from "react-router-dom";
import CaseDetailsHeader from './inspection-mode/CaseDetailsHeader';
const calculateAge = (date) => {
  if (!date) return '';
  const d = dayjs(date);
  const now = dayjs();
  const years = now.diff(d, 'year');
  const months = now.diff(d.add(years, 'year'), 'month');
  return `${years} Year${years !== 1 ? 's' : ''} ${months} Month${months !== 1 ? 's' : ''}`;
};

const AuditDetails = (props) => {
  const theme = createTheme({
    components: {
      MuiInputBase: {
        styleOverrides: {
          root: {
            fontSize: '16px',
          },
        },
      },
    },
  });
  const { audit_id } = useParams();
  
  const [birthDate, setBirthDate] = useState(null);
  const dispatch = useDispatch();
  const [popupVisible, setPopupVisible] = useState(false);
  const [popupMessage, setPopupMessage] = useState('');
  const [cattleCount, setCattleCount] = useState(1);
  const [caseDetails, setCaseDetails] = useState({});
  const [loading, setLoadingState] = useState(false);
  const [form] = Form.useForm();
  const [userId, setUserId] = useState(null);
  const [isFormValid, setIsFormValid] = useState(false);
const location = useLocation();
useEffect(() => {
  const prefill = async () => {
    try {
      // 1) Prefill immediately from navigation state (if available)
      const nav = location.state || {};

      const initial = {
        "Farmer's Name": nav.farmerName || '',
        "Aadhar No.": nav.adhaar || '',
        "Phone no.": '',          // will come from API below
        "Category": '',           // will come from API below
        "Vet's Name": '',         // will come from API below
        "Vet's Email": '',        // will come from API below
        "Vet Phone no": '',       // will come from API below
      };

      // apply navigation state first
      setCaseDetails(prev => ({ ...prev, ...initial }));
      form.setFieldsValue(initial);

      // 2) Fetch full prefill from backend (works on refresh too)
      const res = await axios.get(`/process_data/form-prefill/${audit_id}`);
      const d = res.data?.data || {};
      const dobDayjs = d.dob ? dayjs(d.dob) : null;
      setBirthDate(dobDayjs);
      const mapped = {
        "Farmer's Name": d.farmerName || nav.farmerName || '',
        "Aadhar No.": d.adhaar || nav.adhaar || '',
        // if you want address/tag in form, add those fields in your form too
        "Tag No.": d.eartag || nav.eartag || '',
        "Address": d.address || nav.address || '',
         "Insurance Company": d.insurance_company || '',
        "Phone no.": d.phone || '',
        "Category": d.category || '',
        "Vet's Name": d.vet_name || '',
        "Vet's Email": d.vet_email || '',
        "Vet Phone no": d.vet_phone || '',
        "Cattle Type": d.cattle_type || '',
        "Animal Specification": d.animal_specification || '',
        "Age in Year & Months": d.age_years_months || '',
        
        "Milk Yield": d.milk_yield || '',
          dob: dobDayjs ? dobDayjs.format("YYYY-MM-DD") : null,

      };

      setCaseDetails(prev => ({ ...prev, ...mapped }));
      form.setFieldsValue(mapped);
    } catch (err) {
      console.error("Prefill failed:", err);
    }
  };

  if (audit_id && userId) prefill();
  // run when audit_id/userId changes
}, [audit_id, userId]);
console.log("PARAMS:", useParams());
console.log("PATH:", window.location.pathname);
console.log("STATE:", location.state);

  const generateRandomNDigitString = (n) => {
    const uuid = uuidv4().replace(/-/g, '');
    return uuid.substring(0, n).toUpperCase();
  };


  const generateRandomId = () => {
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let result = '';
    for (let i = 0; i < 4; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters[randomIndex];
    }
    const now = new Date();
    const day = now.getDate().toString().padStart(2, '0');
    const hours = now.getHours().toString().padStart(2, '0');
    const mins = now.getMinutes().toString().padStart(2, '0');
    const secs = now.getSeconds().toString().padStart(2, '0');
    const dateTimePart = day + hours + mins + secs;
    result += dateTimePart;
    return result.slice(0, 12);
  };

  useEffect(() => {
    const uuid = generateRandomNDigitString(10);
    setUserId(uuid);
  }, []);

  // useEffect(() => {
  //   if (userId) {
  //     const cachedCompanies = localStorage.getItem('insuranceUser');
  //     const company = cachedCompanies ? JSON.parse(cachedCompanies).company : '';
  //     setCaseDetails({
  //       "User Id": userId,
  //       "Farmer's Name": '',
  //       "Aadhar No.": '',
  //       "Category": '',
  //       "Phone no.": '',
  //       "Cattle Type": '',
  //       "Animal Specification": '',
  //       "Age in Year & Months": '',
  //       "Milk Yield": '',
  //       "Vet's Name": '',
  //       "Vet's Email": '',
  //       "Vet Phone no": '',
  //       "Insurance Company": "",
  //       "No. of Cattles": 1,
  //     });
  //     // also set form initial values if needed
  //     form.setFieldsValue({
  //       "No. of Cattles": 1,
  //     });
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, [userId]);
useEffect(() => {
  if (!userId) return;

  const cachedCompanies = localStorage.getItem('insuranceUser');
  const company = cachedCompanies ? JSON.parse(cachedCompanies).company : '';

  setCaseDetails(prev => ({
    ...prev,
    "User Id": userId,
    "No. of Cattles": prev["No. of Cattles"] ?? 1,
    "Insurance Company": prev["Insurance Company"] || "",
  }));

  form.setFieldsValue({
    "No. of Cattles": 1,
  });
}, [userId]);

  const handleInputChange = (type, e) => {
    // supports being called with an event or direct value (defensive)
    const value = e && e.target !== undefined ? e.target.value : e;
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: value,
    }));
  };

  const handleSelectionChange = (type, value) => {
    form.setFieldsValue({ [type]: value });
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      [type]: value,
    }));
  };

  const handleDateChange = (date) => {
    // AntD DatePicker might give a moment; convert to dayjs for calculateAge
    const d = date ? dayjs(date) : null;
    setBirthDate(d);
    const age = calculateAge(d);
    // use generic setter (not event) so handleInputChange handles it
    setCaseDetails((prevDetails) => ({
      ...prevDetails,
      'Age in Year & Months': age,
          dob: d ? d.format('YYYY-MM-DD') : null,   // ✅ store for backend

    }));
  };

  const incrementCattle = () => {
    if (cattleCount < 10) {
      const newCount = cattleCount + 1;
      setCattleCount(newCount);
      setCaseDetails((prevDetails) => ({
        ...prevDetails,
        'No. of Cattles': newCount,
      }));
    }
  };

  const decrementCattle = () => {
    if (cattleCount > 1) {
      const newCount = cattleCount - 1;
      setCattleCount(newCount);
      setCaseDetails((prevDetails) => ({
        ...prevDetails,
        'No. of Cattles': newCount,
      }));
    }
  };

  const validateForm = () => {
    const requiredFields = [
      'Category',
      'Phone no.',
      'Cattle Type',
      'Animal Specification',
      'Age in Year & Months',
      'Milk Yield',
      "Vet's Name",
      "Vet's Email",
      "Vet Phone no",
      'Insurance Company',
      'No. of Cattles',
    ];

    // every required field must be present and not blank (special-case numeric count)
    const allPresent = requiredFields.every((field) => {
      const val = caseDetails[field];

      // if field is the numeric count
      if (field === 'No. of Cattles') {
        return typeof val === 'number' ? val > 0 : (val ?? '').toString().trim() !== '' && Number(val) > 0;
      }

      if (val === null || val === undefined) return false;
      // for objects or arrays, consider them valid if not empty
      if (typeof val === 'object') {
        try {
          return Object.keys(val).length > 0;
        } catch (e) {
          return !!val;
        }
      }
      return val.toString().trim() !== '';
    });

    return allPresent && cattleCount > 0;
  };
const generateRandom6DigitCode = () => {
  return Math.floor(100000 + Math.random() * 900000).toString();
};

  useEffect(() => {
    setIsFormValid(validateForm());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [caseDetails, cattleCount]);

  const insuranceUser = (() => {
    try {
      return JSON.parse(localStorage.getItem('insuranceUser'));
    } catch (e) {
      return null;
    }
  })();
  const user_Id = insuranceUser?.userId;
  const insuranceConfig = (() => {
    try {
      return JSON.parse(localStorage.getItem('inspectionConfig'));
    } catch (e) {
      return null;
    }
  })();
const onFinish = async () => {
   console.log("SAVE CLICKED ✅", { audit_id, caseDetails });

  setLoadingState(true);
  dispatch(setLoading(true));

  try {
    // ✅ Save user-entered values so next open prefills
   const resp = await axios.post("/process_data/save-form-fields", {
      audit: audit_id,
      cattle_type: caseDetails["Cattle Type"],
      animal_specification: caseDetails["Animal Specification"],
      age_years_months: caseDetails["Age in Year & Months"],
      milk_yield: caseDetails["Milk Yield"],
        dob: caseDetails.dob,   // ✅ send

    });
    console.log("SAVE RESPONSE ✅", resp.data);

    // then continue your existing flow...
    // await axios.post('/create_audit/get_token', ...)
    // uploads...
    navigate('/auditList');
  } catch (err) {
    console.error(err);
  } finally {
    setLoadingState(false);
    dispatch(setLoading(false));
  }
};

  const navigate = useNavigate();


  return (
    <ThemeProvider theme={theme}>
      <div style={{ 
      height: "100vh",
    overflow: "hidden",   
    display: "flex",}}>
        <style jsx>
          {`
            .input-lowercase::placeholder {
              text-transform: capitalize;
            }
          `}
        </style>

        <div
          className="responsive-form-container"
          style={{
            flex: 1,
            overflowY: 'auto',
            display: 'flex',
            paddingBottom: 'max(70px, env(safe-area-inset-bottom))',
            flexDirection: 'column',
            gap: '16px',
             minHeight: 0,  
          }}
        >
          {loading && (
            <div
              style={{
                position: 'absolute',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(0, 0, 0, 0.3)',
                zIndex: 10,
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
              }}
            >
              <CircularProgress size={40} sx={{ color: '#FC350B' }} />
            </div>
          )}

          <PopupNotification visible={popupVisible} message={popupMessage} onClose={() => setPopupVisible(false)} />
           
           <CaseDetailsHeader/>
          <div className="form-data">
            <div className="audit-details-group" style={{ width: '80vw' }}>
            {/* Farmer's Name */}
<div className="input-wrapper">
	<Form.Item
		name="Farmer's Name"
		rules={[{ required: true, message: "Please enter Farmer's Name" }]}
	>
		<div style={{ position: 'relative' }}>
			<StyledInput
				value={caseDetails["Farmer's Name"]}
				style={{ width: 200 }}
				placeholder=" "
				onChange={e => handleInputChange("Farmer's Name", e)}
			/>
			<span className={caseDetails["Farmer's Name"] ? 'fill' : 'unfilled'}>
				Farmer's Name
			</span>
		</div>
	</Form.Item>
</div>

{/* Aadhar No. */}
<div className="input-wrapper">
	<Form.Item
		name="Aadhar No."
		rules={[{ required: true, message: 'Please enter Aadhar No.' }]}
	>
		<div style={{ position: 'relative' }}>
			<StyledInput
				value={caseDetails['Aadhar No.']}
				style={{ width: 200 }}
				placeholder=" "
				maxLength={12}
				onChange={e => handleInputChange('Aadhar No.', e)}
			/>
			<span className={caseDetails['Aadhar No.'] ? 'fill' : 'unfilled'}>
				Aadhar No.
			</span>
		</div>
	</Form.Item>
</div>

{/* Farmer Address */}
<div className="input-wrapper">
	<Form.Item
		name="Address"
		rules={[{ required: true, message: "Please enter Farmer's address" }]}
	>
		<div style={{ position: 'relative' }}>
			<StyledInput
				value={caseDetails["Address"]}
				style={{ width: 200 }}
				placeholder=" "
				onChange={e => handleInputChange("Farmer's Address", e)}
			/>
			<span className={caseDetails["Address"] ? 'fill' : 'unfilled'}>
				Farmer's Address
			</span>
		</div>
	</Form.Item>
</div>

{/* Tag No. */}
<div className="input-wrapper">
	<Form.Item
		name="Tag No."
		rules={[{ required: true, message: 'Please enter Tag No.' }]}
	>
		<div style={{ position: 'relative' }}>
			<StyledInput
				value={caseDetails['Tag No.']}
				style={{ width: 200 }}
				placeholder=" "
				onChange={e => handleInputChange('Tag No.', e)}
			/>
			<span className={caseDetails['Tag No.'] ? 'fill' : 'unfilled'}>
				Tag No.
			</span>
		</div>
	</Form.Item>
</div>
              {/* Category */}
              <div className="input-wrapper">
                <Form.Item name="Category" rules={[{ required: true, message: 'Please select Category' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Category']}
                      style={{ width: 200 }}
                      onChange={(e) => handleSelectionChange('Category', e)}
                      options={[
                        { value: 'SC', label: 'SC' },
                        { value: 'ST', label: 'ST' },
                        { value: 'General', label: 'General' },
                        { value: 'OBC', label: 'OBC' },
                      ]}
                    />
                    <span className={caseDetails['Category'] ? 'fill' : 'unfilled'}>Category</span>
                  </div>
                </Form.Item>
              </div>

              {/* Phone no. */}
              <div className="input-wrapper">
                <Form.Item name="Phone no." rules={[{ required: true, message: 'Please enter Phone no.' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Phone no.']}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('Phone no.', e)}
                    />
                    <span className={caseDetails['Phone no.'] ? 'fill' : 'unfilled'}>Phone no.</span>
                  </div>
                </Form.Item>
              </div>

              {/* Cattle Type */}
              <div className="input-wrapper">
                <Form.Item name="Cattle Type" rules={[{ required: true, message: 'Please enter Cattle Type' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Cattle Type']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Cattle Type', e)}
                      options={[
                        { value: 'cow', label: 'Cow' },
                        { value: 'buffalo', label: 'Buffalo' },
                      ]}
                    />
                    <span className={caseDetails['Cattle Type'] ? 'fill' : 'unfilled'}>Cattle Type</span>
                  </div>
                </Form.Item>
              </div>

              {/* Animal Specification */}
              <div className="input-wrapper">
                <Form.Item
                  name="Animal Specification"
                  rules={[{ required: true, message: 'Please enter Animal Specification' }]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Animal Specification']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Animal Specification', e)}
                      options={[
                        { value: 'HF', label: 'HF' },
                        { value: 'HF Cross', label: 'HF Cross' },
                        { value: 'Jersey', label: 'Jersey' },
                        { value: 'Jersey Cross', label: 'Jersey Cross' },
                        { value: 'Gir', label: 'Gir' },
                        { value: 'Gir Cross', label: 'Gir Cross' },
                        { value: 'Deoni', label: 'Deoni' },
                        { value: 'Local', label: 'Local' },
                        { value: 'Sahiwal Cross', label: 'Sahiwal Cross' },
                        { value: 'ND', label: 'ND' },
                        { value: 'Murrah', label: 'Murrah' },
                        { value: 'Nagpuri', label: 'Nagpuri' },
                        { value: 'Surti', label: 'Surti' },
                        { value: 'Pandharpuri', label: 'Pandharpuri' },
                        { value: 'Local ND', label: 'Local ND' },
                        { value: 'MR Cross', label: 'MR Cross' },
                        { value: 'Munner Cross', label: 'Munner Cross' },
                        { value: 'ND Cross', label: 'ND Cross' },
                        { value: 'Murrah Cross', label: 'Murrah Cross' },
                      ]}
                    />
                    <span className={caseDetails['Animal Specification'] ? 'fill' : 'unfilled'}>Animal Specification</span>
                  </div>
                </Form.Item>
              </div>

              {/* Age in Year & Months */}
              <div className="input-wrapper">
                <Form.Item name="Age in Year & Months" rules={[{ required: true, message: 'Please enter Age' }]}>
                  <div style={{ position: 'relative', display: 'flex', alignItems: 'center', gap: 10, flexDirection: 'column' }}>
                    <DatePicker
                      className="ant-input"
                      style={{ width: '100%' }}
                      placeholder="Select Date of Birth"
                      format="DD-MM-YYYY"
                        value={birthDate}
                       onChange={handleDateChange}
                    />

                    {caseDetails['Age in Year & Months'] && (
                      <div style={{ marginTop: 4, color: '#555' }}>
                        Age: {caseDetails['Age in Year & Months']}
                      </div>
                    )}
                  </div>
                </Form.Item>
              </div>
                     
              {/* Milk Yield */}
              <div className="input-wrapper">
                <Form.Item name="Milk Yield" rules={[{ required: true, message: 'Please enter Milk Yield' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Milk Yield']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange('Milk Yield', e)}
                    />
                    <span className={caseDetails['Milk Yield'] ? 'fill' : 'unfilled'}>Milk Yield</span>
                  </div>
                </Form.Item>
              </div>

              {/* Vet's Name */}
              <div className="input-wrapper">
                <Form.Item name="Vet's Name" rules={[{ required: true, message: "Please enter Vet's Name" }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails["Vet's Name"]}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange("Vet's Name", e)}
                    />
                    <span className={caseDetails["Vet's Name"] ? 'fill' : 'unfilled'}>Vet's Name</span>
                  </div>
                </Form.Item>
              </div>

              {/* Vet's Email */}
              <div className="input-wrapper">
                <Form.Item
                  name="Vet's Email"
                  rules={[
                    { required: true, message: "Please enter Vet's Email" },
                    { type: 'email', message: 'Please enter a valid email' },
                  ]}
                >
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails["Vet's Email"]}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleInputChange("Vet's Email", e)}
                    />
                    <span className={caseDetails["Vet's Email"] ? 'fill' : 'unfilled'}>Vet's Email</span>
                  </div>
                </Form.Item>
              </div>

              {/* Vet Phone no */}
              <div className="input-wrapper">
                <Form.Item name="Vet Phone no" rules={[{ required: true, message: 'Please enter Phone no.' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledInput
                      value={caseDetails['Vet Phone no']}
                      style={{ width: 200 }}
                      placeholder=" "
                      maxLength={10}
                      onChange={(e) => handleInputChange('Vet Phone no', e)}
                    />
                    <span className={caseDetails['Vet Phone no'] ? 'fill' : 'unfilled'}>Phone no</span>
                  </div>
                </Form.Item>
              </div>

              {/* Insurance Company */}
              <div className="input-wrapper">
                <Form.Item name="Insurance Company" style={{ position: 'relative' }} rules={[{ required: true, message: 'Insurance company is required' }]}>
                  <div style={{ position: 'relative' }}>
                    <StyledSelect
                      value={caseDetails['Insurance Company']}
                      style={{ width: 200 }}
                      placeholder=" "
                      onChange={(e) => handleSelectionChange('Insurance Company', e)}
                      options={[{ value: 'nandi', label: 'Nandi' }]}
                    />
                    <span className={caseDetails['Insurance Company'] ? 'fill' : 'unfilled'}>Insurance Company</span>
                  </div>
                </Form.Item>
              </div>

            
            </div>
<div
  style={{
    padding: '16px',
    textAlign: 'center',
    flexShrink: 0, // ensures it doesn't shrink when scrolling
  }}
>
  <Form.Item style={{ margin: 0 }}>
    <Button
      style={{
        backgroundColor: isFormValid ? '#FC350B' : '#FC350B',
        color: '#FFFFFF',
        minHeight: '40px',
        width: '300px',
        borderRadius: '2px',
      }}
      htmlType="button"
      onClick={onFinish}
    >
      Save
    </Button>
  </Form.Item>
</div>
            {/* <div
              style={{
               position: "static",
                bottom: 30,
                padding: '16px',
                textAlign: 'center',
              }}
            >
              <Form.Item style={{ margin: '0px' }}>
                <Button
                  style={{
                    backgroundColor: isFormValid ? '#FC350B' : '#FC350B',
                    color: '#FFFFFF',
                    minHeight: '40px',
                    width: '300px',
                    borderRadius: '2px',
                  }}
                  htmlType="button"
                  className="responsive-button"
                  onClick={onFinish}
                >
                  Save
                </Button>
              </Form.Item>    
            </div> */}
          </div>
        </div>

        <ToastContainer />
      </div>
    </ThemeProvider>
  );
};

export default AuditDetails;
